/**
 * ObjectFieldSetPanel React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// Material-UI
import {withStyles} from "@material-ui/core";
import ObjectFieldSet from "./ObjectFieldSet";
import ObjectFieldSetSideBar from "./ObjectFieldSetSideBar";

// application components
import PresentationFolderPreview from "../editextensions/PresentationFolderPreview";
import PresentationFilePreview from "../editextensions/PresentationFilePreview";
import PresentationChapterPreview from '../editextensions/PresentationChapterPreview';


// define components for different object types
const objectTopComponents = {
    presentationfolder: PresentationFolderPreview,
    presentationfile: PresentationFilePreview,
    presentationtextchapter: PresentationChapterPreview,
    presentationimagechapter: PresentationChapterPreview,
    presentationvideochapter: PresentationChapterPreview,
    presentationinterviewchapter: PresentationChapterPreview
};


/**
 * ObjectFieldSetPanel is container for object fields plus side bar
 *
 * @author Jens Gruschel
 */
export class ObjectFieldSetPanel extends React.Component {

    render() {

        return <div className={this.props.classes.panel}>
            <div className={this.props.classes.topBar}>
                {this.renderObjectTopComponent()}
            </div>
            <div className={this.props.classes.fieldSetContainer}>
                <ObjectFieldSet
                    fieldDefinitions={this.props.fieldSet.fields}
                    objectId={this.props.objectId}
                    objectFields={this.props.object.fields}
                    readOnly={this.props.readOnly}
                    scope={this.props.scope}
                    onObjectValueChange={this.props.onObjectValueChange}

                />
                <ObjectFieldSetSideBar
                    fieldSet={this.props.fieldSet}
                    sideBarFieldSets={this.props.sideBarFieldSets}
                    objectType={this.props.objectType}
                    objectId={this.props.objectId}
                    object={this.props.object}
                    readOnly={this.props.readOnly}
                    scope={this.props.scope}
                    onObjectValueChange={this.props.onObjectValueChange}
                />
            </div>
        </div>;
    }

    renderObjectTopComponent() {

        const Element = objectTopComponents[this.props.objectType];
        if (!Element) return null;

        const objectProps = {
            place: "top",
            fieldSet: this.props.fieldSet,
            objectType: this.props.objectType,
            objectId: this.props.objectId,
            object: this.props.object,
            readOnly: this.props.readOnly,
            onObjectValueChange: this.props.onObjectValueChange
        };

        return <Element {...objectProps}/>;
    }
}

const styles = theme => ({
    panel: {
        width: "100%"
    },
    topBar: {
        "& > *": {
            marginTop: 20,
            overflow: "hidden"
        }
    },
    fieldSetContainer: {
        width: "100%",
        display: "flex",
        overflowX: "auto"
    }
});

ObjectFieldSetPanel.propTypes = {
    fieldSet: PropTypes.object.isRequired,
    sideBarFieldSets: PropTypes.array,
    objectType: PropTypes.string,
    objectId: PropTypes.string,
    object: PropTypes.object.isRequired,
    readOnly: PropTypes.bool,
    scope: PropTypes.arrayOf(PropTypes.string),
    onObjectValueChange: PropTypes.func.isRequired
};

export default withStyles(styles)(ObjectFieldSetPanel);